var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var axios = require('axios');

var crypto = require('crypto');

var version = 'npm-opennode-v1.2.0';
var instance = undefined;
var api_key;
var env;

function setCredentials() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var environment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'live';
  if (instance !== undefined) return;
  api_key = key;
  instance = axios.create();
  env = environment;
  instance.defaults.baseURL = environment === 'live' ? 'https://api.opennode.com/v1' : 'https://dev-api.opennode.com/v1';
  instance.defaults.timeout = 15000;
  instance.defaults.headers = {
    'Authorization': api_key,
    'user_agent': version
  };
}

function createCharge(_x) {
  return _createCharge.apply(this, arguments);
}

function _createCharge() {
  _createCharge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(charge) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return instance.post("/charges", charge);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            throw Exception(_context.t0.response.status, _context.t0.response.statusText, _context.t0.response.data.message);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _createCharge.apply(this, arguments);
}

function chargeInfo(_x2) {
  return _chargeInfo.apply(this, arguments);
}

function _chargeInfo() {
  _chargeInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return instance.get("/charge/".concat(id));

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.data.data);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            throw Exception(_context2.t0.response.status, _context2.t0.response.statusText, _context2.t0.response.data.message);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _chargeInfo.apply(this, arguments);
}

function listCharges() {
  return _listCharges.apply(this, arguments);
}

function _listCharges() {
  _listCharges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return instance.get("/charges");

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response.data.data);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            throw Exception(_context3.t0.response.status, _context3.t0.response.statusText, _context3.t0.response.data.message);

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _listCharges.apply(this, arguments);
}

function initiateWithdrawal(_x3) {
  return _initiateWithdrawal.apply(this, arguments);
}

function _initiateWithdrawal() {
  _initiateWithdrawal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(withdrawal) {
    var response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            console.warn("This method is deprecated and not recommend for use. Please use the asynchronous version (initiateWithdrawalAsync)");
            _context4.next = 4;
            return instance.post("/withdrawals", withdrawal);

          case 4:
            response = _context4.sent;
            return _context4.abrupt("return", response.data.data);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            throw Exception(_context4.t0.response.status, _context4.t0.response.statusText, _context4.t0.response.data.message);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));
  return _initiateWithdrawal.apply(this, arguments);
}

function withdrawalInfo(_x4) {
  return _withdrawalInfo.apply(this, arguments);
}

function _withdrawalInfo() {
  _withdrawalInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
    var response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return instance.get("/withdrawal/".concat(id));

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response.data.data);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            throw Exception(_context5.t0.response.status, _context5.t0.response.statusText, _context5.t0.response.data.message);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));
  return _withdrawalInfo.apply(this, arguments);
}

function listWithdrawals() {
  return _listWithdrawals.apply(this, arguments);
}

function _listWithdrawals() {
  _listWithdrawals = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return instance.get("/withdrawals");

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response.data.data);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            throw Exception(_context6.t0.response.status, _context6.t0.response.statusText, _context6.t0.response.data.message);

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));
  return _listWithdrawals.apply(this, arguments);
}

function listRates() {
  return _listRates.apply(this, arguments);
}

function _listRates() {
  _listRates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return instance.get("/rates");

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response.data.data);

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            throw Exception(_context7.t0.response.status, _context7.t0.response.statusText, _context7.t0.response.data.message);

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 7]]);
  }));
  return _listRates.apply(this, arguments);
}

function listCurrencies() {
  return _listCurrencies.apply(this, arguments);
}

function _listCurrencies() {
  _listCurrencies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return instance.get("/currencies");

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response.data.data);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            throw Exception(_context8.t0.response.status, _context8.t0.response.statusText, _context8.t0.response.data.message);

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));
  return _listCurrencies.apply(this, arguments);
}

function userBalance() {
  return _userBalance.apply(this, arguments);
}

function _userBalance() {
  _userBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return instance.get("/account/balance");

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response.data.data);

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);
            throw Exception(_context9.t0.response.status, _context9.t0.response.statusText, _context9.t0.response.data.message);

          case 10:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 7]]);
  }));
  return _userBalance.apply(this, arguments);
}

function initiateWithdrawalAsync(_x5) {
  return _initiateWithdrawalAsync.apply(this, arguments);
}

function _initiateWithdrawalAsync() {
  _initiateWithdrawalAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(withdrawal) {
    var new_instance, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            new_instance = axios.create();
            new_instance.defaults.baseURL = env === 'live' ? 'https://api.opennode.com/v2' : 'https://dev-api.opennode.com/v2';
            new_instance.defaults.timeout = 15000;
            new_instance.defaults.headers = {
              'Authorization': api_key,
              'user_agent': version
            };
            _context10.next = 7;
            return new_instance.post('/withdrawals', withdrawal);

          case 7:
            response = _context10.sent;
            return _context10.abrupt("return", response.data.data);

          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](0);
            throw Exception(_context10.t0.response.status, _context10.t0.response.statusText, _context10.t0.response.data.message);

          case 14:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 11]]);
  }));
  return _initiateWithdrawalAsync.apply(this, arguments);
}

function verifySignature(_x6) {
  return _verifySignature.apply(this, arguments);
}

function _verifySignature() {
  _verifySignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(charge) {
    var hash;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            hash = crypto.createHmac('sha256', api_key).update(charge.id).digest('hex');
            return _context11.abrupt("return", hash === charge.hashed_order);

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _verifySignature.apply(this, arguments);
}

function refundCharge(_x7) {
  return _refundCharge.apply(this, arguments);
}

function _refundCharge() {
  _refundCharge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(refund) {
    var response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return instance.post("/refunds", refund);

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response.data.data);

          case 7:
            _context12.prev = 7;
            _context12.t0 = _context12["catch"](0);
            throw Exception(_context12.t0.response.status, _context12.t0.response.statusText, _context12.t0.response.data.message);

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 7]]);
  }));
  return _refundCharge.apply(this, arguments);
}

function listRefunds() {
  return _listRefunds.apply(this, arguments);
}

function _listRefunds() {
  _listRefunds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return instance.get("/refunds");

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response.data.data);

          case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](0);
            throw Exception(_context13.t0.response.status, _context13.t0.response.statusText, _context13.t0.response.data.message);

          case 10:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 7]]);
  }));
  return _listRefunds.apply(this, arguments);
}

function refundInfo(_x8) {
  return _refundInfo.apply(this, arguments);
}

function _refundInfo() {
  _refundInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(id) {
    var response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return instance.get("/refund/".concat(id));

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response.data.data);

          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](0);
            throw Exception(_context14.t0.response.status, _context14.t0.response.statusText, _context14.t0.response.data.message);

          case 10:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 7]]);
  }));
  return _refundInfo.apply(this, arguments);
}

function Exception(statusCode, statusText, message) {
  var error = new Error(message);
  error.name = statusText;
  error.status = statusCode;
  return error;
}

module.exports = {
  setCredentials: setCredentials,
  createCharge: createCharge,
  chargeInfo: chargeInfo,
  listCharges: listCharges,
  initiateWithdrawal: initiateWithdrawal,
  initiateWithdrawalAsync: initiateWithdrawalAsync,
  withdrawalInfo: withdrawalInfo,
  listWithdrawals: listWithdrawals,
  listRates: listRates,
  listCurrencies: listCurrencies,
  signatureIsValid: verifySignature,
  getBalance: userBalance,
  refundCharge: refundCharge,
  listRefunds: listRefunds,
  refundInfo: refundInfo
};